module.exports = __webpack_public_path__ + "img/Enmascarar grupo 19@2x.3d8481cf.png";